'use client';

import { useRouter } from '@/i18n/navigation';
import { auth } from '@/lib/firebase';
import * as UserFactory from '@/services/user';
import type { Spacing } from '@/ui/types';
import cn from 'classnames';
import { GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { SocialButton } from '../SocialButton';
import { SomethingWrong } from '../SomethingWrong';

import s from './Rrss.module.css';

type RrssProps = {
  spacing?: Spacing;
};

const Rrss = ({ spacing }: RrssProps) => {
  const [hasError, setHasError] = useState(false);
  const router = useRouter();
  const t = useTranslations('error_component_rrss');

  const handleGoogleLogin = async () => {
    try {
      setHasError(false);

      const provider = new GoogleAuthProvider();
      const credentials = await signInWithPopup(auth, provider);

      const token = await credentials.user.getIdToken(true);

      await UserFactory.authFederated({ token });

      router.push(`/onboarding`);
    } catch (err) {
      setHasError(true);
      await signOut(auth);
    }
  };

  const handleContact = () => {};

  if (hasError)
    return (
      <SomethingWrong
        title={t('title')}
        description={t('description')}
        primaryButtonLabel={t('primary_button')}
        primaryButtonIcon="Wsp"
        secondaryButtonLabel={t('secondary_button')}
        onPrimaryButtonClick={handleContact}
        onSecondaryButtonClick={() => setHasError(false)}
      />
    );

  return (
    <section className={cn(s.rrss, { [`spacing-${spacing}`]: !!spacing })}>
      <SocialButton variant="google" onClick={handleGoogleLogin} />
    </section>
  );
};

export default Rrss;
